import _ from "lodash";
import type { IWidget, SWItem } from "../widget-types/Widget";
import { getKeyForApi, Widget } from "../widget-types/Widget";
import { SWWidget } from "../widget-types/widget.reg";

interface IWidgetCtor {
    new (): IWidget<any>;

    getAllConfigs?: (params: any) => {
        widgetConfig: any;
        metricConfig: any;
        metricTypeConfig: any;
        apiController: string;
        viewOptions: any;
        context?: string;
    };
}

interface IWidgetFactoryService {
    createWithConfigs<T>(params: any, widgetClass: IWidgetCtor, context: string): IWidget<T>;
    create<T>(widgetConfig: any, context: string): IWidget<T>;
    getKeyForApi(key: SWItem[]);
}

export class WidgetFactoryService implements IWidgetFactoryService {
    constructor(private widgetClasses: { [name: string]: IWidgetCtor }) {}

    createWithConfigs<T>(params: any, widgetClass: IWidgetCtor, context?: string): IWidget<T> {
        if (widgetClass.getAllConfigs) {
            const config = widgetClass.getAllConfigs(params);
            const widget: IWidget<T> = new widgetClass();
            widget.initWidgetWithConfigs(config, context);
            widget.runWidget();
            return widget;
        } else {
            // Sentry.error(`${widgetClass.name} must implement getAllConfigs()`);
            return null;
        }
    }

    createAllWithConfigs<T>(params: any, WidgetsClasses: any, context?: string) {
        return Object.entries<any>(WidgetsClasses).reduce((targetInstacesCollection, [widgetName, widgetClass]) => {
            return {
                ...targetInstacesCollection,
                [widgetName]: this.createWithConfigs(params, widgetClass, context),
            };
        }, {});
    }

    create<T>(widgetConfig: any, context?: string): IWidget<T> {
        if (widgetConfig instanceof Widget) {
            return widgetConfig as any;
        }
        // Deserialize JSON string properties when coming from server
        if (_.isString(widgetConfig.properties)) {
            try {
                widgetConfig.properties = JSON.parse(widgetConfig.properties || "{}");
            } catch (e) {
                return null;
            }
        }
        if (_.isString(widgetConfig.pos)) {
            widgetConfig.pos = JSON.parse(widgetConfig.pos || "{}");
        }
        const widgetType = widgetConfig.type || widgetConfig.properties.type;

        const widgetTypeClass = `${widgetType}Widget`;
        const ctor = this.widgetClasses[widgetTypeClass];

        if (!ctor) {
            return null;
        }
        if (typeof ctor === "function") {
            const widget: IWidget<T> = new ctor();
            widget.initWidget(widgetConfig, context);
            widget.runWidget();
            return widget;
        }
    }

    getKeyForApi(key: SWItem[]) {
        return getKeyForApi(key);
    }
}

export default new WidgetFactoryService(SWWidget);
